module.exports = "<em pTooltip=\"{{this.msgToDisplay}}\" tooltipPosition=\"{{this.positionOfMsg}}\" class=\"fa fa-info-circle remove-padd\"></em>"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/components/tooltip/tooltip.component.html
// module id = ../../../../../src/app/shared/components/tooltip/tooltip.component.html
// module chunks = main